/* tslint:disable */
/* eslint-disable */
/**
 * Swagger LogisticProcess - OpenAPI 3.0
 * Activity of the warehouse
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ActivityCreatedResponse {
    'message'?: string;
    'code'?: string;
}
export interface ActivityRequest {
    'date'?: string;
    'frontUuid'?: string;
    'processId'?: number;
    'minutes'?: number;
}
export interface ActivityUpdateRequest {
    'date'?: string;
    'collaboratorId'?: number;
    'processId'?: number;
    'minutes'?: number;
}
export interface CategoriesWithHours {
    'category'?: Category;
    'hours'?: number;
}
export interface Category {
    'id'?: number;
    'name'?: string;
    'description'?: string;
}
export interface ColTeam {
    'id'?: number;
    'name'?: string;
}
export interface CollaboratorActivityHours {
    'minutes'?: number;
}
export interface CollaboratorResponse {
    'id'?: number;
    'name'?: string;
    'username'?: string;
    'sapNumber'?: string;
    'team'?: ColTeam;
    'uuid'?: string;
    'manual'?: boolean;
    'siteFedidCodes'?: Array<SiteFedidCodeRequest>;
}
export interface EconomicBodyResponse {
    'team'?: string;
    'totalHda'?: string;
    'totalHours'?: string;
    'categories'?: Array<string>;
    'difference'?: string;
    'totalHoursProvider'?: string;
}
export interface EconomicFooterResponse {
    'title'?: string;
    'totalHda'?: string;
    'totalHours'?: string;
    'categories'?: Array<string>;
    'difference'?: string;
    'totalHoursProvider'?: string;
}
export interface EconomicHeadResponse {
    'team'?: string;
    'totalHda'?: string;
    'totalHours'?: string;
    'categories'?: Array<string>;
    'difference'?: string;
    'totalHoursProvider'?: string;
}
export interface HoursByCollaboratorIdAndDates {
    'date'?: string;
    'totalHours'?: string;
    'totalHoursProvider'?: string;
    'listProcesses'?: Array<LogProcessValueResponse>;
}
export interface HoursByCollaboratorIdAndDatesBody {
    'date'?: string;
    'totalHours'?: string;
    'totalHoursProvider'?: string;
    'listProcesses'?: Array<LogisticProcessesResponseWithTotalHours>;
    'polyvalenceGiven'?: string;
}
export interface HoursByProcessAndDate {
    'processId'?: number;
    'minutes'?: number;
    'teamId'?: number;
}
export interface HoursPolyvalenceByCollaboratorIdAndDates {
    'date'?: string;
    'totalHours'?: string;
    'totalHoursInTeam'?: string;
    'team'?: Array<TeamWithLogisticProcess>;
}
export interface HoursPolyvalenceByCollaboratorIdAndDatesHead {
    'date'?: string;
    'totalHours'?: string;
    'team'?: string;
    'logisticProcess'?: string;
    'hours'?: string;
}
export interface ListEconomicDtoResponse {
    'head'?: EconomicHeadResponse;
    'body'?: Array<EconomicBodyResponse>;
    'footer'?: EconomicFooterResponse;
}
export interface ListHoursByCollaboratorIdAndDatesWithTotalHours {
    'head'?: HoursByCollaboratorIdAndDates;
    'body'?: Array<HoursByCollaboratorIdAndDatesBody>;
}
export interface ListHoursPolyvalenceByCollaboratorIdAndDatesWithTotalHours {
    'totalHoursActivities'?: number;
    'listHoursPolyvalenceByCollaboratorIdAndDates'?: Array<HoursPolyvalenceByCollaboratorIdAndDates>;
}
export interface ListPolyvalenceGivenByCollaboratorAndDatesResponse {
    'head'?: HoursPolyvalenceByCollaboratorIdAndDatesHead;
    'body'?: Array<HoursPolyvalenceByCollaboratorIdAndDates>;
}
export interface ListPolyvalenceGivenResponse {
    'head'?: PolyvalenceGivenHead;
    'body'?: Array<PolyvalenceGiven>;
}
export interface ListPolyvalenceReceivedResponse {
    'head'?: PolyvalenceReceivedHead;
    'body'?: Array<PolyvalenceReceived>;
}
export interface ListSumTotalHoursLogisticProcessByCollaboratorResponse {
    'head'?: TeamActivityHeadResponse;
    'body'?: Array<TeamActivityBodyResponse>;
    'footer'?: TeamActivityFooterResponse;
}
export interface LogProcessValueResponse {
    'value'?: string;
    'isDangerous'?: boolean;
    'maxMinutesInversion'?: number;
    'isEnabled'?: boolean;
}
export interface LogisticProcessesResponse {
    'id'?: number;
    'name'?: string;
    'isEnabled'?: boolean;
    'isDangerous'?: boolean;
    'maxMinutesInversion'?: number;
}
export interface LogisticProcessesResponseWithTotalHours {
    'logisticProcessDTO'?: LogisticProcessesResponse;
    'hours'?: number;
    'dangerous'?: boolean;
}
export interface PolyvalenceGiven {
    'collaborator'?: CollaboratorResponse;
    'totalHours'?: string;
    'team'?: Array<TeamWithLogisticProcess>;
}
export interface PolyvalenceGivenHead {
    'collaboratorName'?: string;
    'username'?: string;
    'totalHours'?: string;
    'team'?: string;
    'logisticProcess'?: string;
    'hours'?: string;
}
export interface PolyvalenceReceived {
    'collaborator'?: CollaboratorResponse;
    'totalHours'?: string;
    'team'?: string;
    'dangerousProcess'?: boolean;
    'logisticProcess'?: Array<LogProcessValueResponse>;
}
export interface PolyvalenceReceivedHead {
    'collaboratorName'?: string;
    'username'?: string;
    'totalHours'?: string;
    'team'?: string;
    'logisticProcess'?: Array<LogProcessValueResponse>;
}
export interface SiteFedidCodeRequest {
    'siteCode'?: string;
}
export interface SumTotalHourPerLogisticProcessDto {
    'logisticProcessDTO'?: LogisticProcessesResponse;
    'sumTotalHours'?: number;
}
export interface Team {
    'id'?: number;
    'name'?: string;
    'description'?: string;
}
export interface TeamActivityBodyResponse {
    'collaborator'?: CollaboratorResponse;
    'totalHours'?: string;
    'totalHoursProvider'?: string;
    'diff'?: string;
    'totalDays'?: number;
    'hoursTeam'?: string;
    'polyvalenceGiven'?: string;
    'polyvalenceReceived'?: string;
    'dangerous'?: boolean;
    'processesHours'?: Array<LogProcessValueResponse>;
}
export interface TeamActivityFooterResponse {
    'title'?: string;
    'totalHours'?: string;
    'totalHoursProvider'?: string;
    'totalDays'?: string;
    'diff'?: string;
    'hoursTeam'?: string;
    'polyvalenceGiven'?: string;
    'polyvalenceReceived'?: string;
    'processesHours'?: Array<LogProcessValueResponse>;
}
export interface TeamActivityHeadResponse {
    'collaboratorName'?: string;
    'username'?: string;
    'totalHours'?: string;
    'totalHoursProvider'?: string;
    'diff'?: string;
    'totalDays'?: string;
    'hoursTeam'?: string;
    'polyvalenceGiven'?: string;
    'polyvalenceReceived'?: string;
    'processesHours'?: Array<LogProcessValueResponse>;
}
export interface TeamResponse {
    'id': number;
    'name': string;
    'description': string;
    'uuid'?: string;
    'sapStructureNumber'?: string;
}
export interface TeamWithLogisticProcess {
    'team'?: TeamResponse;
    'logisticProcessWithHoursDTOList'?: Array<LogisticProcessesResponseWithTotalHours>;
}
export interface TotalHoursTeamWithCategories {
    'team'?: Team;
    'listCategories'?: Array<CategoriesWithHours>;
    'hoursProvider'?: number;
    'hoursActivities'?: number;
}

/**
 * ActivitiesApi - axios parameter creator
 */
export const ActivitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new activity of a collaborator
         * @summary Create Activity
         * @param {Array<ActivityRequest>} activityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity: async (activityRequest: Array<ActivityRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityRequest' is not null or undefined
            assertParamExists('createActivity', 'activityRequest', activityRequest)
            const localVarPath = `/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity of a collaborator
         * @summary Get Activity of a collaborator
         * @param {number} processId logistic process
         * @param {number} collaboratorId collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorActivityHours: async (processId: number, collaboratorId: number, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCollaboratorActivityHours', 'processId', processId)
            // verify required parameter 'collaboratorId' is not null or undefined
            assertParamExists('getCollaboratorActivityHours', 'collaboratorId', collaboratorId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getCollaboratorActivityHours', 'date', date)
            const localVarPath = `/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (processId !== undefined) {
                localVarQueryParameter['process_id'] = processId;
            }

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Economic Reportt
         * @summary Get report economic
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEconomicReport: async (startDate: string, endDate: string, siteCodeFedid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getEconomicReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getEconomicReport', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/economic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteCodeFedid !== undefined) {
                localVarQueryParameter['site_code_fedid'] = siteCodeFedid;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Hours By collaborator and Dates
         * @summary Get Hours By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoursByCollaboratorIdAndDates: async (startDate: string, endDate: string, collaboratorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getHoursByCollaboratorIdAndDates', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getHoursByCollaboratorIdAndDates', 'endDate', endDate)
            const localVarPath = `/v1/activities/hoursByCollaboratorIdAndDates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Hours Polyvalence By collaborator and Dates
         * @summary Get Hours Polyvalence By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Collaborator Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoursPolyvalenceByCollaboratorIdAndDates: async (startDate: string, endDate: string, collaboratorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getHoursPolyvalenceByCollaboratorIdAndDates', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getHoursPolyvalenceByCollaboratorIdAndDates', 'endDate', endDate)
            const localVarPath = `/v1/activities/hoursPolyvalenceByCollaboratorIdAndDates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours of Polyvalence given
         * @summary Get Total Hours of Polyvalence given
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceGiven: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPolyvalenceGiven', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPolyvalenceGiven', 'endDate', endDate)
            const localVarPath = `/v1/activities/polyvalenceGiven`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours of Polyvalence Received
         * @summary Get Total Hours of Polyvalence Received
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceReceived: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPolyvalenceReceived', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPolyvalenceReceived', 'endDate', endDate)
            const localVarPath = `/v1/activities/polyvalenceReceived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceReceivedReport: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getPolyvalenceReceivedReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getPolyvalenceReceivedReport', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/polyvalenceReceivedReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get report polyvalence report by collaborator Id and dates
         * @summary Get polyvalence report by collaborator Id and dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportHoursPolyvalenceByCollaboratorAndDates: async (startDate: string, endDate: string, collaboratorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getReportHoursPolyvalenceByCollaboratorAndDates', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getReportHoursPolyvalenceByCollaboratorAndDates', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/reportHoursPolyvalenceByCollaboratorAndDates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours Collaborator and dates
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByCollaboratorAndDatesReport: async (startDate: string, endDate: string, collaboratorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalHoursByCollaboratorAndDatesReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTotalHoursByCollaboratorAndDatesReport', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/totalHoursByCollaboratorAndDates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get report of total hours of the logistic processes by a team
         * @summary Get report of total hours of the logistic processes by a team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByCollaboratorReport: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalHoursByCollaboratorReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTotalHoursByCollaboratorReport', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/totalHoursByCollaborator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get total hours by process and date
         * @summary Get total hours by process and date
         * @param {string} date date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByProcessAndDate: async (date: string, collaboratorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getTotalHoursByProcessAndDate', 'date', date)
            const localVarPath = `/v1/activities/totalHoursByProcessAndDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours of the Teams By Site Code
         * @summary Get Total Hours of the Teams By Site Code
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursCategoriesOfTeamsBySiteCode: async (startDate: string, endDate: string, siteCodeFedid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalHoursCategoriesOfTeamsBySiteCode', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTotalHoursCategoriesOfTeamsBySiteCode', 'endDate', endDate)
            const localVarPath = `/v1/activities/economic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteCodeFedid !== undefined) {
                localVarQueryParameter['site_code_fedid'] = siteCodeFedid;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours of the logistic processes by Collaborator
         * @summary Get Total Hours of the logistic processes by Collaborator
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursLogisticProcessesByCollaborator: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalHoursLogisticProcessesByCollaborator', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTotalHoursLogisticProcessesByCollaborator', 'endDate', endDate)
            const localVarPath = `/v1/activities/totalHoursByCollaborator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getpolyvalenceGivenReport: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getpolyvalenceGivenReport', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getpolyvalenceGivenReport', 'endDate', endDate)
            const localVarPath = `/v1/activities/report/polyvalenceGivenReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update hour activity or Create hour Activity if not exists
         * @summary Update hour activity or Create hour Activity if not exists
         * @param {ActivityUpdateRequest} activityUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoursActivity: async (activityUpdateRequest: ActivityUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityUpdateRequest' is not null or undefined
            assertParamExists('updateHoursActivity', 'activityUpdateRequest', activityUpdateRequest)
            const localVarPath = `/v1/activities/updateHoursActivity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesApi - functional programming interface
 */
export const ActivitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new activity of a collaborator
         * @summary Create Activity
         * @param {Array<ActivityRequest>} activityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivity(activityRequest: Array<ActivityRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivity(activityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.createActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity of a collaborator
         * @summary Get Activity of a collaborator
         * @param {number} processId logistic process
         * @param {number} collaboratorId collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorActivityHours(processId: number, collaboratorId: number, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollaboratorActivityHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorActivityHours(processId, collaboratorId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getCollaboratorActivityHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Economic Reportt
         * @summary Get report economic
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEconomicReport(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEconomicReport(startDate, endDate, siteCodeFedid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getEconomicReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Hours By collaborator and Dates
         * @summary Get Hours By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHoursByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHoursByCollaboratorIdAndDatesWithTotalHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHoursByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getHoursByCollaboratorIdAndDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Hours Polyvalence By collaborator and Dates
         * @summary Get Hours Polyvalence By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Collaborator Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHoursPolyvalenceByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPolyvalenceGivenByCollaboratorAndDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHoursPolyvalenceByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getHoursPolyvalenceByCollaboratorIdAndDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours of Polyvalence given
         * @summary Get Total Hours of Polyvalence given
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolyvalenceGiven(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPolyvalenceGivenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolyvalenceGiven(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getPolyvalenceGiven']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours of Polyvalence Received
         * @summary Get Total Hours of Polyvalence Received
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolyvalenceReceived(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPolyvalenceReceivedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolyvalenceReceived(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getPolyvalenceReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolyvalenceReceivedReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolyvalenceReceivedReport(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getPolyvalenceReceivedReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get report polyvalence report by collaborator Id and dates
         * @summary Get polyvalence report by collaborator Id and dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReportHoursPolyvalenceByCollaboratorAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReportHoursPolyvalenceByCollaboratorAndDates(startDate, endDate, collaboratorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getReportHoursPolyvalenceByCollaboratorAndDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours Collaborator and dates
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursByCollaboratorAndDatesReport(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursByCollaboratorAndDatesReport(startDate, endDate, collaboratorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getTotalHoursByCollaboratorAndDatesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get report of total hours of the logistic processes by a team
         * @summary Get report of total hours of the logistic processes by a team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursByCollaboratorReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursByCollaboratorReport(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getTotalHoursByCollaboratorReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get total hours by process and date
         * @summary Get total hours by process and date
         * @param {string} date date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursByProcessAndDate(date: string, collaboratorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HoursByProcessAndDate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursByProcessAndDate(date, collaboratorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getTotalHoursByProcessAndDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours of the Teams By Site Code
         * @summary Get Total Hours of the Teams By Site Code
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursCategoriesOfTeamsBySiteCode(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEconomicDtoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursCategoriesOfTeamsBySiteCode(startDate, endDate, siteCodeFedid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getTotalHoursCategoriesOfTeamsBySiteCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours of the logistic processes by Collaborator
         * @summary Get Total Hours of the logistic processes by Collaborator
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursLogisticProcessesByCollaborator(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSumTotalHoursLogisticProcessByCollaboratorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursLogisticProcessesByCollaborator(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getTotalHoursLogisticProcessesByCollaborator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getpolyvalenceGivenReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getpolyvalenceGivenReport(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.getpolyvalenceGivenReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update hour activity or Create hour Activity if not exists
         * @summary Update hour activity or Create hour Activity if not exists
         * @param {ActivityUpdateRequest} activityUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHoursActivity(activityUpdateRequest: ActivityUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHoursActivity(activityUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesApi.updateHoursActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesApi - factory interface
 */
export const ActivitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesApiFp(configuration)
    return {
        /**
         * Create a new activity of a collaborator
         * @summary Create Activity
         * @param {Array<ActivityRequest>} activityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity(activityRequest: Array<ActivityRequest>, options?: RawAxiosRequestConfig): AxiosPromise<ActivityCreatedResponse> {
            return localVarFp.createActivity(activityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity of a collaborator
         * @summary Get Activity of a collaborator
         * @param {number} processId logistic process
         * @param {number} collaboratorId collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorActivityHours(processId: number, collaboratorId: number, date: string, options?: RawAxiosRequestConfig): AxiosPromise<CollaboratorActivityHours> {
            return localVarFp.getCollaboratorActivityHours(processId, collaboratorId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Economic Reportt
         * @summary Get report economic
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEconomicReport(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getEconomicReport(startDate, endDate, siteCodeFedid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Hours By collaborator and Dates
         * @summary Get Hours By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoursByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListHoursByCollaboratorIdAndDatesWithTotalHours> {
            return localVarFp.getHoursByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Hours Polyvalence By collaborator and Dates
         * @summary Get Hours Polyvalence By collaborator and Dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Collaborator Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHoursPolyvalenceByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListPolyvalenceGivenByCollaboratorAndDatesResponse> {
            return localVarFp.getHoursPolyvalenceByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours of Polyvalence given
         * @summary Get Total Hours of Polyvalence given
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceGiven(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListPolyvalenceGivenResponse> {
            return localVarFp.getPolyvalenceGiven(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours of Polyvalence Received
         * @summary Get Total Hours of Polyvalence Received
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceReceived(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListPolyvalenceReceivedResponse> {
            return localVarFp.getPolyvalenceReceived(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolyvalenceReceivedReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPolyvalenceReceivedReport(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get report polyvalence report by collaborator Id and dates
         * @summary Get polyvalence report by collaborator Id and dates
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportHoursPolyvalenceByCollaboratorAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getReportHoursPolyvalenceByCollaboratorAndDates(startDate, endDate, collaboratorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours Collaborator and dates
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByCollaboratorAndDatesReport(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTotalHoursByCollaboratorAndDatesReport(startDate, endDate, collaboratorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get report of total hours of the logistic processes by a team
         * @summary Get report of total hours of the logistic processes by a team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByCollaboratorReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTotalHoursByCollaboratorReport(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get total hours by process and date
         * @summary Get total hours by process and date
         * @param {string} date date
         * @param {number} [collaboratorId] Id collaborator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursByProcessAndDate(date: string, collaboratorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<HoursByProcessAndDate>> {
            return localVarFp.getTotalHoursByProcessAndDate(date, collaboratorId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours of the Teams By Site Code
         * @summary Get Total Hours of the Teams By Site Code
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {string} [siteCodeFedid] Site Code Fedid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursCategoriesOfTeamsBySiteCode(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig): AxiosPromise<ListEconomicDtoResponse> {
            return localVarFp.getTotalHoursCategoriesOfTeamsBySiteCode(startDate, endDate, siteCodeFedid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours of the logistic processes by Collaborator
         * @summary Get Total Hours of the logistic processes by Collaborator
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursLogisticProcessesByCollaborator(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListSumTotalHoursLogisticProcessByCollaboratorResponse> {
            return localVarFp.getTotalHoursLogisticProcessesByCollaborator(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get report of total hours of the collaborator by team
         * @summary Get report of total hours of the collaborator by team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getpolyvalenceGivenReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getpolyvalenceGivenReport(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update hour activity or Create hour Activity if not exists
         * @summary Update hour activity or Create hour Activity if not exists
         * @param {ActivityUpdateRequest} activityUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHoursActivity(activityUpdateRequest: ActivityUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActivityCreatedResponse> {
            return localVarFp.updateHoursActivity(activityUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesApi - object-oriented interface
 */
export class ActivitiesApi extends BaseAPI {
    /**
     * Create a new activity of a collaborator
     * @summary Create Activity
     * @param {Array<ActivityRequest>} activityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createActivity(activityRequest: Array<ActivityRequest>, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).createActivity(activityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity of a collaborator
     * @summary Get Activity of a collaborator
     * @param {number} processId logistic process
     * @param {number} collaboratorId collaborator
     * @param {string} date date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorActivityHours(processId: number, collaboratorId: number, date: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getCollaboratorActivityHours(processId, collaboratorId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Economic Reportt
     * @summary Get report economic
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {string} [siteCodeFedid] Site Code Fedid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEconomicReport(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getEconomicReport(startDate, endDate, siteCodeFedid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Hours By collaborator and Dates
     * @summary Get Hours By collaborator and Dates
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [collaboratorId] Id collaborator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHoursByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getHoursByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Hours Polyvalence By collaborator and Dates
     * @summary Get Hours Polyvalence By collaborator and Dates
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [collaboratorId] Collaborator Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHoursPolyvalenceByCollaboratorIdAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getHoursPolyvalenceByCollaboratorIdAndDates(startDate, endDate, collaboratorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours of Polyvalence given
     * @summary Get Total Hours of Polyvalence given
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolyvalenceGiven(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getPolyvalenceGiven(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours of Polyvalence Received
     * @summary Get Total Hours of Polyvalence Received
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolyvalenceReceived(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getPolyvalenceReceived(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get report of total hours of the collaborator by team
     * @summary Get report of total hours of the collaborator by team
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolyvalenceReceivedReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getPolyvalenceReceivedReport(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get report polyvalence report by collaborator Id and dates
     * @summary Get polyvalence report by collaborator Id and dates
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [collaboratorId] Id collaborator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getReportHoursPolyvalenceByCollaboratorAndDates(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getReportHoursPolyvalenceByCollaboratorAndDates(startDate, endDate, collaboratorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours Collaborator and dates
     * @summary Get report of total hours of the collaborator by team
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [collaboratorId] Id collaborator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursByCollaboratorAndDatesReport(startDate: string, endDate: string, collaboratorId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getTotalHoursByCollaboratorAndDatesReport(startDate, endDate, collaboratorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get report of total hours of the logistic processes by a team
     * @summary Get report of total hours of the logistic processes by a team
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursByCollaboratorReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getTotalHoursByCollaboratorReport(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get total hours by process and date
     * @summary Get total hours by process and date
     * @param {string} date date
     * @param {number} [collaboratorId] Id collaborator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursByProcessAndDate(date: string, collaboratorId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getTotalHoursByProcessAndDate(date, collaboratorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours of the Teams By Site Code
     * @summary Get Total Hours of the Teams By Site Code
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {string} [siteCodeFedid] Site Code Fedid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursCategoriesOfTeamsBySiteCode(startDate: string, endDate: string, siteCodeFedid?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getTotalHoursCategoriesOfTeamsBySiteCode(startDate, endDate, siteCodeFedid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours of the logistic processes by Collaborator
     * @summary Get Total Hours of the logistic processes by Collaborator
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursLogisticProcessesByCollaborator(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getTotalHoursLogisticProcessesByCollaborator(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get report of total hours of the collaborator by team
     * @summary Get report of total hours of the collaborator by team
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getpolyvalenceGivenReport(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).getpolyvalenceGivenReport(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update hour activity or Create hour Activity if not exists
     * @summary Update hour activity or Create hour Activity if not exists
     * @param {ActivityUpdateRequest} activityUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateHoursActivity(activityUpdateRequest: ActivityUpdateRequest, options?: RawAxiosRequestConfig) {
        return ActivitiesApiFp(this.configuration).updateHoursActivity(activityUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



